// Standalone file for static, site-wide message banners.

import { createContext } from "react";
import { ISitewideMessageBanner } from "./message-indicators";

type TSitewideMessageBannerContext = {
  messages: ISitewideMessageBanner[];
};
const SitewideMessageBannerContext =
  createContext<TSitewideMessageBannerContext | null>(null);

export default SitewideMessageBannerContext;

// Hard-code which messages should be constantly shown to users. In the future,
// we should implement a proper announcements model and API endpoint in the
// backend. But this works for now to get out urgent messages.
export const sitewideMessageBannerData: TSitewideMessageBannerContext = {
  messages: [],
};
